export default __webpack_public_path__ + "static/media/miami.f0669783.jpg";